import { useEffect, useState } from 'react'
import { Link } from 'react-router'
import { CouponCard } from '../components/coupons/CouponCard'
import { siteConfig } from '../config/site'
import { coupons, getActiveCoupons, offerTerms } from '../data/coupons'

const title = 'Pack Print Mail Coupons & Special Offers | Waxahachie'
const description = 'View current Pack Print Mail coupons and special offers for printing, packing, business services and digital marketing in Waxahachie, Texas.'

export function CouponsPage() {
  const [now, setNow] = useState(() => new Date())
  useEffect(() => {
    const refresh = () => setNow(new Date())
    const timer = setInterval(refresh, 30_000)
    window.addEventListener('focus', refresh)
    return () => { clearInterval(timer); window.removeEventListener('focus', refresh) }
  }, [])
  const activeOffers = getActiveCoupons(coupons, now)
  const canonical = `${siteConfig.siteUrl}/coupons`

  return <article className="coupons-page">
    <title>{title}</title><meta name="description" content={description} />
    <link rel="canonical" href={canonical} /><meta property="og:type" content="website" />
    <meta property="og:site_name" content={siteConfig.displayName} /><meta property="og:title" content={title} />
    <meta property="og:description" content={description} /><meta property="og:url" content={canonical} />
    <header className="coupons-hero"><div className="coupons-shell">
      <p className="coupons-eyebrow">Current Offers</p>
      <h1>Save on Printing,<br />Business Services & More</h1>
      <p className="coupons-lead">Check our current Pack Print Mail offers for printing, packing, business services and small-business support.</p>
      <p className="coupons-note">Offers may change periodically. Some exclusions apply.</p>
    </div></header>
    <div className="coupons-shell coupons-body">
      {activeOffers.length ? <>
        <div className="coupons-grid-intro"><p>For your next project. For your growing business.</p><span>{activeOffers.length} current offers</span></div>
        <div className="coupons-grid">{activeOffers.map((coupon) => <CouponCard key={coupon.id} coupon={coupon} />)}</div>
      </> : <section className="coupons-empty"><span aria-hidden="true">✦</span><h2>New Offers Coming Soon</h2><p>Check back for Pack Print Mail promotions on printing, business services and more.</p><Link className="service-button service-button--primary" to="/contact-us">Contact Us</Link></section>}
      <section className="coupons-general-terms"><h2>Offer Terms</h2><p>{offerTerms}</p><Link to="/contact-us">Questions about an offer? Contact Pack Print Mail →</Link></section>
    </div>
  </article>
}
